<template>    
  <nav class="flex space-x-4">
    <button
        @click="currentTab = tabKey"
        :class="{'bg-blue-600 text-white': currentTab === tabKey, 'bg-gray-200 text-gray-700': currentTab !== tabKey}"
        class="tabLink"
        v-for="(tab, tabKey) in tabs"
    >
        {{ tab.label }}
    </button>
  </nav>

  <div>
      <component :is="tabs[currentTab]['component']"></component>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ListingTabs } from '@/models/utility/ListingTabs';

const props = defineProps({
  tabs: {
    type: Object as () => ListingTabs,
    required: true,
  },
  defaultTab: {
    type: String,
    default: null,
  },
})

const currentTab = props.defaultTab ? ref(props.defaultTab) : ref(Object.keys(props.tabs)[0]);
</script>

<style scoped>
.tabLink {
  @apply px-4 py-2 rounded-full focus:outline-none transition duration-300 ease-in-out hover:bg-blue-500 hover:text-slate-100;
}
</style>